import React, { useState, useEffect } from "react";

export const svg = `<svg width="32" height="32" viewbox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="1" y="1" width="14" height="14" rx="3"></rect><path d="M23 17a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2v-3a3 3 0 0 1 3-3h3Zm0 14a2 2 0 0 0-2-2h-2v-2a2 2 0 0 0-2-2v3a3 3 0 0 0 3 3h3Zm4-12a2 2 0 0 1-2-2h3a3 3 0 0 1 3 3v3a2 2 0 0 1-2-2v-2h-2Zm-2 12a2 2 0 0 1 2-2h2v-2a2 2 0 0 1 2-2v3a3 3 0 0 1-3 3h-3ZM7 17a2 2 0 0 1-2 2H3v2a2 2 0 0 1-2 2v-3a3 3 0 0 1 3-3h3Zm0 14a2 2 0 0 0-2-2H3v-2a2 2 0 0 0-2-2v3a3 3 0 0 0 3 3h3Zm4-12a2 2 0 0 1-2-2h3a3 3 0 0 1 3 3v3a2 2 0 0 1-2-2v-2h-2ZM9 31a2 2 0 0 1 2-2h2v-2a2 2 0 0 1 2-2v3a3 3 0 0 1-3 3H9ZM23 1a2 2 0 0 1-2 2h-2v2a2 2 0 0 1-2 2V4a3 3 0 0 1 3-3h3Zm0 14a2 2 0 0 0-2-2h-2v-2a2 2 0 0 0-2-2v3a3 3 0 0 0 3 3h3Zm4-12a2 2 0 0 1-2-2h3a3 3 0 0 1 3 3v3a2 2 0 0 1-2-2V3h-2Zm-2 12a2 2 0 0 1 2-2h2v-2a2 2 0 0 1 2-2v3a3 3 0 0 1-3 3h-3Z"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
